import { type IResponseEventMessage } from 'entities/Message'
import { CallHistory } from 'entities/CallHistory/model/CallHistory'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageUpdatedNewGlobal } from 'entities/Conversation/events/EventMessageUpdatedNewGlobal'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventMessageUpdatedNew = (callHistoryStore: CallHistoryStore) => {
  const entities = useEntitiesContext()
  const { inboxesStore } = entities
  const handler = (data: IResponseEventMessage) => {
    const { call_history, conversation } = data
    if (!call_history || inboxesStore.currentInboxTypeId !== conversation.inbox_id) return

    const { call } = call_history
    const { type, outcome } = call

    if (type && outcome) {
      callHistoryStore.callHistoryTableStore.updateItem(new CallHistory(call_history, entities))
    }
  }

  useEventMessageUpdatedNewGlobal(handler)
}
